export const stayPromotions = {
  title: "Promoções de estadia",
  description: "Ofereça descontos especiais aos seus hóspedes para estadias mais longas",
  newPromotion: "Nova promoção",
  loading: "Carregando promoções...",
  close: "Fechar",
  cancel: "Cancelar",
  noLimit: "Sem limite",

  status: {
    active: "Ativa",
    paused: "Pausada",
  },

  card: {
    stay: "Estadia",
    discount: "Desconto",
    validity: "Validade",
    edit: "Editar",
    delete: "Excluir",
  },

  nights: {
    range: "{min} - {max} noites",
    min: "{min}+ noites",
  },

  empty: {
    title: "Nenhuma promoção configurada",
    description: "Crie promoções para incentivar estadias mais longas e aumentar suas reservas",
    create: "Criar primeira promoção",
  },

  form: {
    editTitle: "Editar promoção",
    createTitle: "Nova promoção",
    nameLabel: "Nome da promoção",
    namePlaceholder: "ex.: desconto de 7 noites, Oferta semanal",
    minNights: "Noites mínimas",
    maxNights: "Noites máximas",
    optional: "(opcional)",
    noLimitPlaceholder: "Sem limite",
    discountType: "Tipo de desconto",
    percentage: "Percentual",
    fixedAmount: "Valor fixo",
    discountValue: "Valor do desconto",
    validFrom: "Válida a partir de",
    validTo: "Válida até",
    activateNow: "Ativar promoção imediatamente",
    saving: "Salvando...",
    update: "Atualizar",
    create: "Criar promoção",
  },

  invoice: {
    title: "Exemplo de economia",
    pricePerNight: "Preço por noite",
    numberOfNights: "Número de noites",
    subtotal: "Subtotal",
    discountApplied: "Desconto aplicado",
    totalToPay: "Total a pagar",
    guestSaves: "O hóspede economiza {amount}",
  },

  statusModal: {
    activateTitle: "Ativar promoção",
    pauseTitle: "Pausar promoção",
    activateDescription: 'Deseja ativar a promoção "{name}" para que ela se aplique a novas reservas?',
    pauseDescription: 'Deseja pausar a promoção "{name}"?',
    confirm: "Confirmar",
  },

  deleteModal: {
    title: "Excluir promoção",
    warningStrong: "Esta ação não pode ser desfeita.",
    warningText: "Antes de excluir, verifique se você não precisa mais da promoção {name}.",
    confirmLabel: "Digite o nome exato para confirmar:",
    confirmPlaceholder: "Digite o nome da promoção exatamente",
    hint: "Cole ou digite o nome exatamente como aparece acima para habilitar o botão de excluir.",
    deleting: "Excluindo...",
    confirmDelete: "Excluir permanentemente",
  },

  toasts: {
    nameRequired: "Informe um nome",
    minNightsWarning: "As noites mínimas devem ser 1 ou mais",
    selectRatePlan: "Selecione um plano tarifário base",
    updated: "Promoção atualizada",
    created: "Promoção criada",
    saveFailed: "Não foi possível salvar",
    saveError: "Erro ao salvar",
    activated: "Promoção ativada",
    pausedToast: "Promoção pausada",
    updateFailed: "Não foi possível atualizar",
    statusError: "Erro ao alterar o status",
    deleted: "Promoção excluída",
    deleteFailed: "Não foi possível excluir",
    deleteError: "Erro ao excluir",
  },
};
